// Centralized breakpoint constants (sync with SCSS variables):
// $screen-xs-min: 320px;
// $screen-xs-max: 543px;
// $screen-sm-min: 544px;
// $screen-sm-max: 767px;
// $screen-md-min: 768px;
// $screen-md-max: 1024px;
// $screen-lg-min: 1025px;
// $screen-lg-max: 1225px;
// $screen-xl-min: 1226px;

export const BREAKPOINTS = Object.freeze({
  XS_MIN: 320,
  XS_MAX: 543,
  SM_MIN: 544,
  SM_MAX: 767,
  MD_MIN: 768,
  MD_MAX: 1024,
  LG_MIN: 1025,
  LG_MAX: 1225,
  XL_MIN: 1226,
});

export function getViewportWidth() {
  return window.innerWidth || document.documentElement.clientWidth || 0;
}

// Evaluate via matchMedia (no layout reads) rather than window.innerWidth.
// matchMedia is cached per query by the browser and never forces a reflow,
// so these can be called freely even right after DOM writes.
const matchesRange = (min: number, max: number) =>
  window.matchMedia(`(min-width: ${min}px) and (max-width: ${max}px)`).matches;

const matchesMin = (min: number) =>
  window.matchMedia(`(min-width: ${min}px)`).matches;

export const breakpoint = {
  isXs: () => matchesRange(BREAKPOINTS.XS_MIN, BREAKPOINTS.XS_MAX),
  isSm: () => matchesRange(BREAKPOINTS.SM_MIN, BREAKPOINTS.SM_MAX),
  isMd: () => matchesRange(BREAKPOINTS.MD_MIN, BREAKPOINTS.MD_MAX),
  isLg: () => matchesRange(BREAKPOINTS.LG_MIN, BREAKPOINTS.LG_MAX),
  isXl: () => matchesMin(BREAKPOINTS.XL_MIN),
  name: () => getBreakpointName(),
  isSmDown: () => window.matchMedia(`(max-width: ${BREAKPOINTS.SM_MAX}px)`).matches,
  isLgUp: () => matchesMin(BREAKPOINTS.LG_MIN),
};

export function inRange(min: number, max: number) {
  return matchesRange(min, max);
}

export function getBreakpointName() {
  if (breakpoint.isXs()) return "xs";
  if (breakpoint.isSm()) return "sm";
  if (breakpoint.isMd()) return "md";
  if (breakpoint.isLg()) return "lg";
  if (breakpoint.isXl()) return "xl";
  return "unknown";
}
